/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPaymentGateway } from 'app/shared/model/payment-gateway.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ITenantPaymentGateway {
  id?: string;
  merchantId?: string;
  merchantKey?: string;
  merchantKeyIndex?: string | null;
  apiVersion?: number | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  tenantId?: string | null;
  gateway?: IPaymentGateway | null;
}

export const defaultValue: Readonly<ITenantPaymentGateway> = {
  active: false,
  draft: false,
};
